import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { mixpanelEvents, useTrackEvent } from '../../utils/mixpanel';
import { makeAPIRequestReactQuery } from '../api';
import { endpoints } from '../endpoints';

import type {
  GetInsightsProviderRequest,
  THygieneTasksDrilldown,
} from './types';

export const useGetHygieneProviderInsightsData = (
  options: GetInsightsProviderRequest,
) => {
  const { providerId, start, end, shouldUseMockData, practiceId } = options;
  const { primaryOrganizationId: orgId } = useSelector(
    (state: any) => state.login.user,
  );
  const { trackEvent } = useTrackEvent();

  const benchmarkType = `hygiene-tasks`;
  const insightsApiPath = `/${endpoints.videaInsights}/${orgId}/${benchmarkType}/${providerId}`;

  return useQuery<THygieneTasksDrilldown[]>({
    queryKey: [insightsApiPath, orgId, start, end, shouldUseMockData],
    queryFn: async () => {
      const startTime = performance.now();
      const response = await makeAPIRequestReactQuery<THygieneTasksDrilldown[]>(
        insightsApiPath,
        {
          start,
          end,
          priorStart: start, // TODO: Update nucleus to remove this requirement
          priorEnd: end, // TODO: Update nucleus to remove this requirement
          practiceId,
          returnSampleResponse: shouldUseMockData,
        },
        'get',
        {
          headers: {
            Org: orgId,
          },
        },
      );

      const loadTime = performance.now() - startTime;
      trackEvent(mixpanelEvents.insightsViewLoad, {
        loadTime,
        organizationId: orgId,
        practiceId: options.practiceId,
        dashboard: 'HYGIENE',
        drilldown: true,
        providerId,
      });

      return response;
    },
    enabled: providerId !== undefined,
  });
};
